var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "1200px" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c("v-icon", [_vm._v("edit")]),
              _vm._v(" Modificar días de reserva\n      "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                { staticClass: "px-3 py-1" },
                [
                  _vm.form.id_persona
                    ? _c("DatosPersonalesProgramacion", {
                        attrs: {
                          id_estado_vacacion: _vm.form.id_estado_vacacion
                        },
                        model: {
                          value: _vm.total_dias_programar,
                          callback: function($$v) {
                            _vm.total_dias_programar = $$v
                          },
                          expression: "total_dias_programar"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "px-0 py-1" },
                [
                  _c(
                    "v-container",
                    [
                      _c("v-flex", { attrs: { xs12: "" } }, [
                        _c("h4", [
                          _c("strong", [
                            _vm._v(
                              "Detalle papeletas registradas con los días de reserva"
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        { staticClass: "pb-0" },
                        [
                          _vm.sw_programacion
                            ? _c(
                                "v-card",
                                {
                                  staticClass:
                                    "px-3 white--text text-xs-center text-md-left",
                                  attrs: { color: "rgba(0, 92, 167, 0.699)" }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs12: "", md4: "" } },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "caption" },
                                            [_vm._v("DÍAS RESERVA")]
                                          ),
                                          _c("br"),
                                          _vm._v(" "),
                                          !!_vm.datos_estado_vacacion
                                            ? _c(
                                                "span",
                                                { staticClass: "display-1" },
                                                [
                                                  _vm._v(
                                                    "\n              " +
                                                      _vm._s(
                                                        _vm
                                                          .datos_estado_vacacion
                                                          .dias_reserva
                                                      ) +
                                                      "\n            "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs12: "", md4: "" } },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "caption" },
                                            [_vm._v("DÍAS RESERVA SOLICITADOS")]
                                          ),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "display-1" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.total_dias_creados_reserva
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs12: "", md4: "" } },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "caption" },
                                            [_vm._v("NOTA A CONSIDERAR")]
                                          ),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "titulo" },
                                            [
                                              _vm._v(
                                                "Los días de reserva se encontrarán vigentes desde el   " +
                                                  _vm._s(
                                                    _vm
                                                      .$moment(
                                                        _vm.datos_programacion
                                                          .fecha_corte
                                                      )
                                                      .format("DD/MM/YYYY")
                                                  ) +
                                                  " hasta el 31/12/" +
                                                  _vm._s(
                                                    _vm.datos_programacion
                                                      .gestion - 1
                                                  ) +
                                                  ", posterior a esta fecha los días no utilizados se adicionarán al total de días no programados de vacación (según corresponde) "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _c(
                                "v-card",
                                {
                                  staticClass: "px-3 white--text",
                                  attrs: { color: "blue" }
                                },
                                [
                                  _c("span", { staticClass: "caption" }, [
                                    _vm._v("TOTAL DÍAS NO PROGRAMADOS")
                                  ]),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "contenido" }, [
                                    _vm._v(
                                      _vm._s(_vm.total_vacacion_disponible)
                                    )
                                  ])
                                ]
                              )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            [
                              _vm.vacaciones_detalle.length > 0
                                ? _c("v-data-table", {
                                    staticClass:
                                      "elevation-1 tabla-comprimida-light",
                                    attrs: {
                                      v: "",
                                      items: _vm.vacaciones_detalle,
                                      "hide-actions": "",
                                      headers: _vm.headers
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "items",
                                          fn: function(props) {
                                            return [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        props.item.nro_dias
                                                      ) +
                                                      " \n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        props.item.fecha_desde
                                                      ) +
                                                      " \n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        props.item.fecha_hasta
                                                      ) +
                                                      " \n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        props.item.nro_dias
                                                      ) +
                                                      " \n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        props.item
                                                          .estado_permiso
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      850544839
                                    )
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "px-3 py-1" },
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", md5: "" } },
                        [
                          _c("v-text-field", {
                            staticClass: "text-field-reducido-border",
                            attrs: {
                              type: "number",
                              label: "Días reserva",
                              outline: "",
                              clearable: "",
                              rules: [
                                function(v) {
                                  return (
                                    v >= 0 || "Introduzca un valor mayor a 0"
                                  )
                                }
                              ]
                            },
                            model: {
                              value: _vm.dias_reserva,
                              callback: function($$v) {
                                _vm.dias_reserva = $$v
                              },
                              expression: "dias_reserva"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { xs12: "", md1: "" } }),
                      _vm._v(" "),
                      _vm.datos_estado_vacacion &&
                      _vm.datos_estado_vacacion.dias_excedentes > 0
                        ? _c("v-flex", { attrs: { xs12: "", md5: "" } }, [
                            _vm._v(
                              "\n            * Se le informa que se añadirán " +
                                _vm._s(
                                  _vm.datos_estado_vacacion &&
                                    _vm.datos_estado_vacacion.dias_excedentes
                                ) +
                                " días adicionales a los días de reserva, ya que estos días podrian perderse\n        "
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "pr-4" },
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("save")]),
                      _vm._v("\n          Guardar\n        ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error" },
                      on: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.cancel")) + "\n        "
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-abd0f586", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abd0f586","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_rrhh/dialogs/EditarDiasReservaOtros.vue
// module id = null
// module chunks = 